import styles from './chat-input-shell.module.scss'

export function ChatInputShellSpacer() {
  return <span className={styles.spacer} />
}
